export enum HTTPMethods {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  PUT = 'PUT',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
}
